import { BuildingFilterModel } from 'src/app/shared/models/building-filter.model';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Select, Store } from '@ngxs/store';
import { BuildingState } from '../../ngxs/state/building.state';
import { BuildingModel } from '../../models/building.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FilterService } from '../../services/filter.service';
import { FilterBuildings } from '../../ngxs/action/building.action';
import { LanguageType } from '../../models/enum.model';

@Component({
  selector: 'app-buildings-simple',
  templateUrl: './buildings-simple.component.html',
  styleUrls: ['./buildings-simple.component.scss'],
})
export class BuildingsSimpleComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  @ViewChild('paginator')
  paginator: MatPaginator;

  @Select(BuildingState.buildings)
  buildings$: Observable<BuildingModel[]>;

  @Select(BuildingState.filter)
  filter$: Observable<BuildingFilterModel>;

  @Select(BuildingState.buildingsTotal)
  buildingsTotal$: Observable<number>;

  dataSource = new MatTableDataSource<BuildingModel>();
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];
  total = 0;

  currentFilter: BuildingFilterModel;

  columnsToDisplay: string[] = [
    'street',
    'construction',
    'municipality',
    'city',
    'actions',
  ];

  constructor(
    private dialog: MatDialog,
    private store: Store,
    private router: Router,
    private translateService: TranslateService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;

    this.store.dispatch(
      new FilterBuildings(
        this.filterService.generateHttpParams(),
        new BuildingFilterModel(
          [],
          [],
          '',
          '',
          [],
          0,
          0,
          LanguageType[this.translateService.currentLang.toUpperCase()]
        )
      )
    );

    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.buildings$.subscribe((x) => {
        this.dataSource = new MatTableDataSource<BuildingModel>(x);
      })
    );

    this.subscription.add(
      this.buildingsTotal$.subscribe((x) => {
        if (x) {
          this.total = x;
        }
      })
    );

    this.subscription.add(
      this.filter$.subscribe((x) => {
        if (x) {
          this.currentFilter = x;
        }
      })
    );
  }

  getYear(data: string) {
    return new Date(data).getFullYear();
  }

  goToDetails(element: BuildingModel) {
    this.router.navigate([`/building/${element.id}/preview`]);
  }

  changePage(event: PageEvent) {
    this.filterService.page = event;

    this.store.dispatch(
      new FilterBuildings(
        this.filterService.generateHttpParams(),
        this.currentFilter ? this.currentFilter : undefined
      )
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
